import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { real_estate_api } from '@axo/shared/data-access/api';
import { realEstateKeys } from '../../cache-keys/realEstateKeys';

export function useFindRealEstates({
  personID,
  includeAll,
  ids,
}: {
  personID?: string;
  includeAll?: boolean;
  ids?: string[];
}) {
  const api = useAPI();

  return useQuery({
    queryKey: [realEstateKeys.list({ personID })],
    queryFn: ({ queryKey: [{ personID }] }) =>
      real_estate_api.findRealEstate(api)({ personID }),
    enabled:
      api.token.length > 0 &&
      !!personID &&
      (ids === undefined || ids.length > 0),
  });
}
